import { putMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const UPDATE_DOCTOR_EARNING = 'UPDATE_DOCTOR_EARNING';
export const UPDATE_DOCTOR_EARNING_SUCCESS = 'UPDATE_DOCTOR_EARNING_SUCCESS';
export const UPDATE_DOCTOR_EARNING_FAILURE = 'UPDATE_DOCTOR_EARNING_FAILURE';

// Action Creators
export const getUpdateDoctorEarning = () => ({
  type: UPDATE_DOCTOR_EARNING,
});

export const getUpdateDoctorEarningSuccess = (users) => ({
  type: UPDATE_DOCTOR_EARNING_SUCCESS,
  payload: users,
});

export const getUpdateDoctorEarningFailure = (error) => ({
  type: UPDATE_DOCTOR_EARNING_FAILURE,
  payload: error,
});

// Thunk Function
export const updateDoctorEarningDataCallAPI = (external, body) => {
  return async (dispatch) => {
    dispatch(getUpdateDoctorEarning());
    try {
      const queryParams = new URLSearchParams();

      if (body.appointment_id) {
        queryParams.append('appointment_id', body.appointment_id);
      }
      if (body.start_date) {
        queryParams.append('start_date', body.start_date);
      }
      if (body.end_date) {
        queryParams.append('end_date', body.end_date);
      }

      const response = await putMethodWithToken(
        `${url?.updateDoctorEarning}${external?.providerId}/?${queryParams.toString()}`,
        {}
      );

      if (response?.status === 200 || response?.status === 201) {
        dispatch(getUpdateDoctorEarningSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getUpdateDoctorEarningFailure('error?.message'));
      }
    } catch (error) {
      dispatch(getUpdateDoctorEarningFailure(error?.message));
    }
  };
};
